// New ITG JS For Store Location
// Handles the opening and closing behavior of a custom dropdown.
$(document).ready(function () {
  $(".custom-dropdown").on("click", function () {
    $(this).toggleClass("open");
  });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".custom-dropdown").length) {
      $(".custom-dropdown").removeClass("open");
    }
  });
});

// Handles dynamic location filtering based on the selected city from a dropdown.
// $(document).ready(function () {
//   $("#country-dropdown").on("change", function () {
//     var selectedCity = $(this).find(":selected").data("city");
//     console.log(selectedCity);
//     $(".location-wrapper").hide();
//     $(".location-wrapper, .location-title").each(function () {
//       var cityTitle = $(this).data("title");
//       if (cityTitle === selectedCity) {
//         $(this).show();
//       }
//     });
//   });
// });

// // Handle .state click event
// $(".state").on("click", function () {
//   var city = $(this).data("city");
//   console.log("State selected: " + city);

//   $(".location-wrapper").hide();
//   $(".location-wrapper").each(function () {
//     if ($(this).data("city") === city) {
//       $(this).show();
//     }
//   });
// });

// // Handle .country-subdropdown click event
$(document).on("click", ".custom-dropdown .country-subdropdown", function () {
  var isState = $(this).hasClass("state");
  var selectCity = $(this).data("city");

  console.log("Selected: " + selectCity);

  $(".custom-dropdown .country-subdropdown").removeClass("selected");

  if (isState) {
    $(this).addClass("selected");
    $(".first-custom-dropdown").text($(this).text());
    return;
  }

  $(this).addClass("selected");

  $(".first-custom-dropdown").text($(this).text());
});

// Hide When we select State 

// $(document).on("click", ".custom-dropdown .country-subdropdown", function () {
//   var isState = $(this).hasClass("state");
//   var selectCity = $(this).data("city");

//   console.log("Selected: " + selectCity);


//   $(".custom-dropdown .country-subdropdown").removeClass("selected");


//   if (isState) {
//     $(this).addClass("selected");
//     $(".first-custom-dropdown").text($(this).text());


//     $(".location-title").hide();
    
//     return;
//   }


//   $(this).addClass("selected");
//   $(".first-custom-dropdown").text($(this).text());


//   $(".location-title").show();

//   $(".location-wrapper").hide();


//   $(".store-locator").each(function () {
//     var found = false;
//     $(this)
//       .find(".location-wrapper")
//       .each(function () {
//         var cityTitle = $(this).data("title");
//         if (cityTitle === selectCity) {
//           $(this).show();
//           found = true;
//         }
//       });

//     if (found) {
//       $(this).removeClass("hide");
//     } else {
//       $(this).addClass("hide");
//     }
//   });
// });

$(document).on('click','#country-dropdown .country-subdropdown',function(){
  var citys = $(this).data('city');
  $(document).find('.location-wrapper').each(function(){
    var locationCity = $(this).data('city');
    var dataTitle = $(this).data('title');
    var dataCountry = $(this).data('country');
    if(citys == locationCity || citys == dataTitle || citys == dataCountry){
      $(this).show();
      $(this).closest('.store-locator').find('.location-title').show();
    }else{
      $(this).hide();
       $(this).closest('.store-locator').find('.location-title').hide();
    }
  });
});
    




